import React, { createContext, forwardRef, useContext, useState, useEffect } from 'react';
import _ from 'lodash';

export const FormContext = createContext();


export default forwardRef((props, ref) => {
  

  // Set the form value to the passed in `value`

  const [value, setValue] = useState(props.value || {});
  
  
  // Update the local cache when the passed in value changes.
  
  useEffect(() => setValue(props.value), [props.value]);


  // If there is already a parent form, just pass through to that context,
  // otherwise create new context.

  let ctx = useContext(FormContext);
  if(!ctx) {
    ctx = {
      // Getter and setter to interact with the form value.
      get(name=null) {
        if(name === null) {
          return value;
        }
        return _.get(value, name, "");
      },
      set(name, val) {
        let updatedValue = {...value};
        _.set(updatedValue, name, val);
        setValue(updatedValue);
        if(props.onChange) {
          props.onChange(updatedValue);
        }
      }
    };
  }


  // Handle form submission.

  function handleSubmit(e) {
    e.preventDefault();
    if(props.onSubmit) {
      props.onSubmit(value);
    }
  }


  // Render the DOM

  return (
    <FormContext.Provider value={ctx}>
      <form onSubmit={handleSubmit} style={props.style} ref={ref} className={props.className}>
        {props.children}
        <button type="submit" style={{display:'none'}}/>
      </form>
    </FormContext.Provider>
  );

});